<template>
  <span
    class="tint-bolt-brand"
    :style="{ '--tb-brand-height': `${height}px` }"
    role="img"
    aria-label="Tint Bolt"
  >
    <img :src="tintBoltMark" alt="" aria-hidden="true" />
    <span class="tint-bolt-wordmark" aria-hidden="true">Tint Bolt</span>
  </span>
</template>

<script setup>
import tintBoltMark from "../assets/Tint_Bolt_Logo.png";

defineProps({
  height: {
    type: Number,
    default: 40,
  },
});
</script>

<style scoped>
.tint-bolt-brand {
  display: inline-flex;
  width: max-content;
  height: var(--tb-brand-height);
  align-items: center;
  gap: calc(var(--tb-brand-height) * 0.2);
  color: #111827;
  white-space: nowrap;
}

.tint-bolt-brand img {
  width: auto;
  height: 100%;
  object-fit: contain;
}

.tint-bolt-wordmark {
  font-family: Inter, Poppins, ui-sans-serif, system-ui, sans-serif;
  font-size: calc(var(--tb-brand-height) * 0.32);
  font-weight: 800;
  letter-spacing: 0.16em;
  line-height: 1;
  text-transform: uppercase;
}

</style>

<style>
.dark .tint-bolt-brand {
  color: #f9fafb;
}
</style>
